import { render, staticRenderFns } from "./PostImage.vue?vue&type=template&id=051055ec&scoped=true&lang=pug"
import script from "./PostImage.vue?vue&type=script&lang=js"
export * from "./PostImage.vue?vue&type=script&lang=js"
import style0 from "./PostImage.vue?vue&type=style&index=0&id=051055ec&prod&lang=sass&nolang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051055ec",
  null
  
)

export default component.exports